import Auth0ErrorHandler from './component'
export default Auth0ErrorHandler



// WEBPACK FOOTER //
// ./src/components/Auth0ErrorHandler/index.js